// How much someone wants a place or goal: their tier (DESIGN.md, Interest; features/interest.md). Three since
// 2026-10-21 (the founder: "simplify votes to just 3 options"): No, Maybe, Yes, and nothing between. Plain
// values, used by the server and the web view alike.

// The three, in the order they're offered as buttons, left to right, wherever they are (a card's strip, an
// option, a pick, a suggestion, the deck): No, Maybe, Yes. "No" read "Not interested" from 2026-10-21 to
// 2026-10-23, and "yes" was "must" until 2026-10-23, when the founder made it "yes" all the way down, so the
// word an AI reads is the word people see.
export const TIERS = ["no", "maybe", "yes"] as const;
export type Tier = (typeof TIERS)[number];

// The same, as lists read them, Yes first (People, everyone's rating on a card, a notification's places).
export const TIERS_LISTED = ["yes", "maybe", "no"] as const;

export const isTier = (value: unknown): value is Tier => TIERS.includes(value as Tier);

// The tiers there were before, and what each became when a migration moved every stored rating: 0048 made
// `want` a must (a real yes) and `if_time` a maybe (2026-10-21), and 0050 made every `must` a `yes`
// (2026-10-23); 0051 said any still stored as this says, then a check made the database refuse all three
// (2026-10-24). The change log keeps what was said before as it was said; undoing such a change, or telling
// the others about it, says what it became.
export const MIGRATED: Readonly<Record<string, Tier>> = { must: "yes", want: "yes", if_time: "maybe" };

// A tier as it is now: one of the three, or what an old one became.
export function migratedTier<T extends string | null | undefined>(tier: T): T | Tier {
  return typeof tier === "string" && tier in MIGRATED ? (MIGRATED[tier] as Tier) : tier;
}

// What an AI hears when it writes or asks for a tier that isn't one (the old ones included): never mapped
// silently, so it learns the three (the founder's pick).
export const TIER_HINT =
  'a tier is "no" (not interested), "maybe" or "yes" (really want it); "must" is now "yes", "want" too, and "if_time" "maybe"';
